import { useTranslation } from 'react-i18next';

export function IntroSection() {
  const { t } = useTranslation();
  
  return (
    <section id="intro" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('intro_title')}<span className="text-blue-600">{t('intro_title_highlight')}</span>
            </h2>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong>{t('intro_company_name')}</strong>（{t('intro_company_name_en')}）{t('intro_founded')}<strong>{t('intro_founded_year')}</strong>{t('intro_desc_1')}
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('intro_desc_2')}<strong>{t('hero_product_1')}</strong>、<strong>{t('hero_product_2')}</strong>、<strong>{t('hero_product_3')}</strong>{t('intro_desc_3')}
            </p>
            
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="bg-blue-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-lg mb-4">
                  <i className="ri-calendar-line text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-blue-600 mb-2">{t('intro_stat_year')}</h3>
                <p className="text-gray-600">{t('intro_stat_year_label')}</p>
              </div>
              
              <div className="bg-blue-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-lg mb-4">
                  <i className="ri-global-line text-2xl"></i>
                </div>
                <h3 className="text-3xl font-bold text-blue-600 mb-2">{t('intro_stat_coverage')}</h3>
                <p className="text-gray-600">{t('intro_stat_coverage_label')}</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/3eaaa53dbbc3399805fa034934fbb500.jpg"
                alt={t('intro_company_name')}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 rounded-xl shadow-xl">
              <p className="text-4xl font-bold mb-2">{t('intro_experience')}</p>
              <p className="text-sm">{t('intro_experience_label')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
